import React, { FC } from 'react';
import Icon from 'src/common/components/IconDS22';
import s from './PhotoUploaderPlaceholder.module.scss';

const PhotoUploaderPlaceholder: FC = () => (
  <div className={s.root}>
    <div className={s.photo}>
      <Icon id="photo" size="xl" />
    </div>
    <div className={s.photo}>
      <Icon id="photo" size="xl" />
    </div>
    <div className={s.photo}>
      <Icon id="photo" size="xl" />
    </div>
  </div>
);

export default PhotoUploaderPlaceholder;
